import React from "react";

const TwitterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        d="M12 .5c3.176 0 6.05 1.287 8.132 3.368A11.464 11.464 0 0 1 23.5 12c0 3.176-1.287 6.05-3.368 8.132A11.464 11.464 0 0 1 12 23.5c-3.176 0-6.05-1.287-8.132-3.368A11.464 11.464 0 0 1 .5 12c0-3.176 1.287-6.05 3.368-8.132A11.464 11.464 0 0 1 12 .5Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M15.719 10.28c.012.053.02.137.02.254 0 .937-.229 1.842-.684 2.715a5.577 5.577 0 0 1-1.972 2.206c-.924.612-1.986.917-3.183.917a5.687 5.687 0 0 1-3.144-.917c.143.013.306.02.488.02.95 0 1.803-.294 2.558-.88a1.91 1.91 0 0 1-1.2-.4 2.04 2.04 0 0 1-.713-1.005c.13.013.253.02.37.02.183 0 .365-.02.547-.06a2.068 2.068 0 0 1-1.171-.722 1.967 1.967 0 0 1-.469-1.288v-.04c.287.17.593.26.918.274a2.275 2.275 0 0 1-.664-.742 1.975 1.975 0 0 1-.254-.986c0-.358.098-.7.293-1.025a5.658 5.658 0 0 0 1.865 1.523c.735.378 1.52.585 2.352.625a2.845 2.845 0 0 1-.038-.469c0-.364.09-.706.273-1.025a2.008 2.008 0 0 1 1.757-1.025c.3 0 .576.058.83.176.254.116.479.273.674.468a4.154 4.154 0 0 0 1.308-.488c-.156.482-.455.86-.898 1.133.39-.053.78-.163 1.171-.333a4.517 4.517 0 0 1-1.034 1.075Z"
      />
    </g>
  </svg>
);

export default TwitterIcon;
